export default function PauseIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      className={className}
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.46387 17.6021C5.93262 17.6021 5.49544 17.4333 5.15234 17.0957C4.81478 16.7637 4.646 16.3459 4.646 15.8423V4.17969C4.646 3.67611 4.81478 3.2583 5.15234 2.92627C5.49544 2.5887 5.93262 2.41992 6.46387 2.41992C6.99512 2.41992 7.42952 2.5887 7.76709 2.92627C8.11019 3.2583 8.28174 3.67611 8.28174 4.17969V15.8423C8.28174 16.3459 8.11019 16.7637 7.76709 17.0957C7.42952 17.4333 6.99512 17.6021 6.46387 17.6021ZM13.5278 17.6021C12.9966 17.6021 12.5594 17.4333 12.2163 17.0957C11.8787 16.7637 11.71 16.3459 11.71 15.8423V4.17969C11.71 3.67611 11.8787 3.2583 12.2163 2.92627C12.5594 2.5887 12.9966 2.41992 13.5278 2.41992C14.0535 2.41992 14.488 2.5887 14.8311 2.92627C15.1742 3.2583 15.3457 3.67611 15.3457 4.17969V15.8423C15.3457 16.3459 15.1742 16.7637 14.8311 17.0957C14.488 17.4333 14.0535 17.6021 13.5278 17.6021Z" />
    </svg>
  );
}
